import { getAdditionalQueryParams } from "../../../selectors";
import { setAdditionalQueryParams } from "../../store/actionCreators";

const resetAdditionalQueryParams = (dispatch, state, specificParam = false) => {
  const additionalQueryParams = getAdditionalQueryParams(state);
  if (!specificParam) {
    return dispatch(setAdditionalQueryParams({}));
  } else {
    if (additionalQueryParams?.[specificParam]) {
      const updatedParams = { ...additionalQueryParams };
      delete updatedParams[specificParam];
      dispatch(setAdditionalQueryParams(updatedParams));
    }
  }
};

export default resetAdditionalQueryParams;
